package ui.external.materialui

object TypographyVariant {
    const val h3 = "h3"
    const val h5 = "h5"
    const val h6 = "h6"
    const val subtitle2 = "subtitle2"
    const val body2 = "body2"
}
